import {TransformationObject} from './QuickTrialScreen';
import {MiniFileData} from './quickTrial';
import React from 'react';
import {CaptionIcon, CropIcon, Colors, Format, Background, Quality} from 'src/ui-components/Iconpack';
import {TransformSubMenu} from './components/TransformaSubMenu';
import {QualitySubMenu} from './components/QualitySubMenu';
import {EffectsSubMenu} from './components/EffectsSubMenu';
import {FormatSubMenu} from './components/FormatSubMenu';
import {BackgroundSubMenu} from './components/BackgroundSubMenu';
import {AnnotationSubMenu} from './components/AnnotationSubMenu';

interface SideMenuProps {
    color: string;
}

interface SideMenuLinkProps {
    title: string;
    icon: React.FC<SideMenuProps>;
    display: boolean;
    mobileAvailable: boolean;
    componentView: (props: {
        fileData?: MiniFileData;
        transformationObject: TransformationObject;
        updateTransformationObject: (updatedProps: TransformationObject) => void;
        orgUid: string;
        trackEvent: (id: string, props: Object) => void;
        trackError: (e: any, id: string, props: Object) => void;
    }) => React.ReactNode;
}

export const QuickTrialSideMenuItems: SideMenuLinkProps[] = [
    {
        title: 'Transform',
        icon: CropIcon,
        display: true,
        mobileAvailable: true,
        componentView: (props) => <TransformSubMenu {...props} />,
    },
    {
        title: 'Caption',
        icon: CaptionIcon,
        display: true,
        mobileAvailable: true,
        componentView: (props) => <AnnotationSubMenu {...props} />,
    },
    {
        title: 'Format',
        icon: Format,
        display: true,
        mobileAvailable: false,
        componentView: (props) => <FormatSubMenu {...props} />,
    },
    {
        title: 'Background',
        icon: Background,
        display: true,
        mobileAvailable: true,
        componentView: (props) => <BackgroundSubMenu {...props} />,
    },
    {
        title: 'Effects',
        icon: Colors,
        display: true,
        mobileAvailable: false,
        componentView: (props) => <EffectsSubMenu {...props} />,
    },
    {
        title: 'Quality',
        icon: Quality,
        display: true,
        mobileAvailable: false,
        componentView: (props) => <QualitySubMenu {...props} />,
    },
];
